import {
  ListProductsResponseType,
  ListPublishableProductsResponseType,
  ShowProductType,
  ProductRefusedReasonResponseType,
  ListProductsSoldResponseType,
  ProductionRole,
} from "@@types/IProduct";
import { ListProductOutput } from "@_types/product/Product.use-cases";
import { ResponsePaginationType } from "@_types/shared";
import { api } from "@services/apiClient";

export async function fetchProduct(uuid: string): Promise<ShowProductType> {
  const { data } = await api.get(`/products/${uuid}`);
  return data;
}

export async function fetchProductEvaluationReason(uuid: string): Promise<ProductRefusedReasonResponseType> {
  const { data } = await api.get(`/products/${uuid}/evaluation-reason`);
  return data;
}

export async function fetchProducts(
  params?: {
    page: number;
    pageSize: number;
    initialDateInterval?: string;
    finishDateInterval?: string;
    categoryUuid?: string;
    status?: string[];
    format?: string[];
    productionRole?: ProductionRole[];
  },
  body?: {
    search?: string;
  }
): Promise<ResponsePaginationType<ListProductOutput>> {
  const status = params?.status;
  const statusString = status ? status.join(",") : undefined;
  const type = params?.format;
  const typeString = type ? type.join(",") : undefined;

  const productionRole = params?.productionRole?.length ? params.productionRole.join() : undefined;

  const finalParams = params ? { ...params, status: statusString, format: typeString, productionRole } : undefined;

  const { data } = await api.get("/products", { params: finalParams, data: body });
  return data;
}

export async function fetchProductsPublishable(
  params: { page: number; pageSize: number } | undefined
): Promise<ListPublishableProductsResponseType> {
  const { data } = await api.get("/products/publishable", { params });
  return data;
}

export async function fetchProductsSold(): Promise<ListProductsSoldResponseType> {
  const { data } = await api.get("/products/sold");
  return data;
}
